import { message, Button } from 'antd';
import React, { useState } from 'react';

const originalError = message.error;

const ShowMessageWithDetail = ({ errorMessage, detail }) => {
  const [showDetail, setShowDetail] = useState(false);

  const handleToggleDetail = () => {
    setShowDetail(!showDetail);
  };

  return (
    <>
      <span>
        {typeof errorMessage === "object" ? (errorMessage?.content || errorMessage?.message) : errorMessage}
        {detail && <Button type="link" onClick={handleToggleDetail}>显示详情</Button>}
      </span>
      {showDetail && detail && <div>{detail}</div>}
    </>
  );
};

message.error = (errorMessage, detail) => {
  originalError(<ShowMessageWithDetail errorMessage={errorMessage} detail={detail} />);
};
